import React, { memo } from 'react';
export const ModulesSection = () => {
  const modules = [{
    num: '1',
    icon: '🧠',
    title: 'Cuaderno Mente Despierta',
    subtitle: 'Estimulación Cognitiva · +150 Fichas · Letra Grande 2026',
    desc: '30 páginas de ejercicios cognitivos de élite para adultos mayores. Memoria, atención, lenguaje y cálculo organizados en fichas de letra grande. El familiar puede acompañar y guiar sin formación médica previa.',
    includes: ['+150 fichas de estimulación cognitiva', 'Ejercicios de memoria, atención y lenguaje', 'Instrucciones claras para el cuidador', 'Espacio de respuesta en cada actividad', 'Progress Tracker cognitivo mensual', 'Bibliografía científica actualizada 2026']
  }, {
    num: '2',
    icon: '🦵',
    title: 'Guía Movilidad Sin Miedo',
    subtitle: 'Fisioterapia Geriátrica en Casa · Silla y De Pie · Prevención de Caídas',
    desc: '30 páginas de ejercicios físicos adaptados para adultos mayores. Rutinas en silla, ejercicios de equilibrio y protocolo de prevención de caídas. Ilustraciones de cada ejercicio. Sin equipamiento especial.',
    includes: ['Rutinas completas en silla para movilidad reducida', 'Ejercicios de equilibrio y fuerza con apoyo', 'Protocolo paso a paso de prevención de caídas', 'Ilustraciones claras de cada posición', 'Tabla de progresión semanal', 'Señales de alerta para detener el ejercicio']
  }, {
    num: '3',
    icon: '🏥',
    title: 'Protocolo Cuidado Experto',
    subtitle: 'Alzheimer · Parkinson · Diabetes · Hipertensión · 2026',
    desc: '30 páginas de protocolos actualizados para el manejo de las condiciones más frecuentes en el adulto mayor. Qué hacer, qué evitar y cuándo llamar al médico. Explicado para familias y cuidadores sin formación médica.',
    includes: ['Protocolo específico para Alzheimer y demencias', 'Guía de manejo diario del Parkinson', 'Control domiciliario de Diabetes e Hipertensión', 'Señales de alarma con acción inmediata', 'Guía de primeros auxilios geriátricos', 'Recursos y contactos de emergencia Argentina']
  }, {
    num: '4',
    icon: '📋',
    title: 'Bitácora de Control 360',
    subtitle: 'Registro de Salud · Medicación · Presión · Glucemia · Ánimo · Sueño',
    desc: '30 páginas de planillas de registro de salud diseñadas para llevar al médico en cada consulta. Control diario de medicación, presión arterial, glucemia, ánimo y sueño. El registro que todo médico agradece recibir.',
    includes: ['Ficha personal de salud completa', 'Registro semanal de medicación con control de stock', 'Planillas de presión arterial y glucemia 2026', 'Registro de ánimo y bienestar emocional diario', 'Control de calidad del sueño', 'Registro de consultas médicas y estudios']
  }, {
    num: '5',
    icon: '⭐',
    title: 'Guía del Cuidador Estrella',
    subtitle: 'Organización · Límites · Autocuidado · Burnout · Familia · 2026',
    desc: '30 páginas diseñadas para el cuidador. Cómo organizar el día sin agotarse, cómo establecer límites saludables con la familia y cómo evitar el Burnout del cuidador. Para que quien cuida también pueda vivir bien.',
    includes: ['Sistema de bloques de tiempo para el cuidado diario', 'Test de Burnout del cuidador validado 2026', 'Técnicas de descompresión rápida en 5 minutos', 'Mapa familiar del cuidado para distribuir responsabilidades', 'Plan semanal de autocuidado del cuidador', 'Recursos y redes de apoyo en Argentina']
  }];
  const inclusions = ['30 páginas de contenido sin relleno', 'Ilustraciones claras en cada actividad', 'Instrucciones para el cuidador y el familiar', 'Letra grande y legible en todo el material', 'Registros y trackers completables a mano', 'Recomendaciones actualizadas 2026', 'Bibliografía científica validada', 'Branding y fecha 2026 en cada página'];
  return <section id="modulos" className="bg-familia-card py-10 md:py-16 px-4 md:px-6" data-id="element-144">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-145">
        <div className="text-center mb-10 md:mb-16" data-id="element-146">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-147">
            📚 LOS 5 MÓDULOS CENTRALES — <br className="hidden sm:block" data-id="element-148" /> Para
            el cuidado integral del adulto mayor
          </h2>
          <p className="text-familia-gray text-[15px] md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-149">
            Cada módulo es un sistema completo con actividades para el adulto
            mayor, guía para el cuidador o familiar, registros de salud 2026,
            instrucciones claras y recomendaciones profesionales en cada página.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-150">
          {modules.map((m, i) => <div key={i} className="bg-familia-section border border-familia-cyan/25 p-6 md:p-8 rounded-2xl card-hover flex flex-col" data-id="element-151">
              <div className="flex items-center justify-between mb-4" data-id="element-152">
                <span className="text-familia-cyan font-mono font-bold text-xs sm:text-sm" data-id="element-153">
                  MÓDULO {m.num}
                </span>
                <span className="text-3xl md:text-4xl" data-id="element-154">{m.icon}</span>
              </div>
              <h3 className="text-lg md:text-xl font-display font-bold mb-1" data-id="element-155">
                {m.title}
              </h3>
              <p className="text-familia-gold text-xs sm:text-sm font-semibold mb-4" data-id="element-156">
                {m.subtitle}
              </p>
              <p className="text-familia-gray text-[14px] md:text-sm leading-relaxed mb-6" data-id="element-157">
                {m.desc}
              </p>
              <div className="border-t border-white/10 pt-4 mt-auto" data-id="element-158">
                <p className="text-xs font-bold text-white/90 uppercase tracking-wider mb-3" data-id="element-159">
                  Incluye:
                </p>
                <ul className="space-y-2" data-id="element-160">
                  {m.includes.map((item, j) => <li key={j} className="flex items-start gap-2 text-[13px] text-familia-gray" data-id="element-161">
                      <span className="text-familia-cyan shrink-0" data-id="element-162">→</span>
                      <span data-id="element-163">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
        <div className="bg-familia-bg border border-familia-cyan/30 border-dashed p-6 md:p-12 rounded-3xl max-w-4xl mx-auto" data-id="element-164">
          <h4 className="text-lg md:text-xl font-display font-bold mb-6 md:mb-8 text-center" data-id="element-165">
            Cada módulo incluye:
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 md:gap-x-12 gap-y-3 md:gap-y-4" data-id="element-166">
            {inclusions.map((item, i) => <div key={i} className="flex items-center gap-3 md:gap-4" data-id="element-167">
                <span className="text-familia-green text-lg md:text-xl" data-id="element-168">
                  ✅
                </span>
                <span className="text-[14px] sm:text-base font-medium" data-id="element-169">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};